import { z } from "zod";
import {
  DateTypeSchema,
  RoleTypeSchema,
  SourceTypeSchema,
} from "./core.schema";
import { BaseFirestoreSchema } from "./firestore.schema";
import { ContactInfoSchema } from "./contactInfo.schema";

// Schemas

export const UserIndexDocumentSchema = z.object({
  _source: SourceTypeSchema,
  emails: z.string().array(),
});

export const UserSchema = BaseFirestoreSchema.merge(ContactInfoSchema).extend({
  emailVerified: z.boolean().nullable().optional(),
  image: z.string().nullable().optional(),
  lastLoginTime: DateTypeSchema.optional(),
  superAdmin: z.boolean().optional(),
  subscriptionId: z.string().optional(),
  subscriptionStatus: z.string().optional(),
  stripeCustomerId: z.string().optional(),
  termsAndConditionsAccepted: z.boolean().optional(),
  termsAndConditionsAcceptedAt: DateTypeSchema.optional(),
  termsAndConditionsAcceptedVersion: z.number().optional(),
});

export const UserWRoleSchema = UserSchema.extend({
  role: RoleTypeSchema,
});

export const UserImportDataSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  salutation: z.string(),
  role: RoleTypeSchema,
  primaryAddress: z.object({
    type: z.string(),
    street: z.string(),
    street2: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
    country: z.string(),
  }),
  isUserValid: z.boolean(),
  isDuplicate: z.boolean().optional(),
});

export const UserDuplicateSchema = z.object({
  user: UserImportDataSchema,
  oldRole: RoleTypeSchema,
  newRole: RoleTypeSchema,
});

export const PublicUserSchema = UserSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  firstName: true,
  lastName: true,
  salutation: true,
  // email: true,
  // primaryAddress: true,
  // primaryPhone: true,
});

// DTOs

export const CreateUserDtoSchema = UserSchema.partial().and(
  UserSchema.required().pick({
    email: true,
    firstName: true,
    lastName: true,
  })
);

export const PutUserDtoSchema = CreateUserDtoSchema;

export const PatchUserDtoSchema = UserSchema.partial();
